<template>
  <div
    v-if="model.hasApprovers"
    class="task-approver-cell"
    data-testid="tasklist__approver-cell"
  >
    <div
      v-if="showL1Stack"
      data-testid="tasklist__approver-cell-l1"
    >
      <ApproverAvatarStack
        :group="model.l1"
        test-id-prefix="tasklist__approver-l1"
      />
    </div>

    <span
      v-if="model.requiresSignOff && model.l2 && model.l2.users.length"
      class="task-approver-cell__separator"
      aria-hidden="true"
      data-testid="tasklist__approver-cell-separator"
    >
      <img
        src="/img/icons/fbc-icons/down-arrow.svg"
        alt=""
        class="task-approver-cell__separator-image"
      />
    </span>

    <div
      v-if="model.requiresSignOff && model.l2 && model.l2.users.length"
      data-testid="tasklist__approver-cell-l2"
    >
      <ApproverAvatarStack
        :group="model.l2"
        test-id-prefix="tasklist__approver-l2"
      />
    </div>
  </div>
</template>

<script>
import './TaskApproverCell.scss';
import ApproverAvatarStack from './ApproverAvatarStack.vue';
import { buildTaskApproverCellModel } from '../../utils/taskApproverCellUtils';

export default {
  name: 'TaskApproverCell',

  components: {
    ApproverAvatarStack,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
    userMap: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    model() {
      return buildTaskApproverCellModel(this.task, this.userMap);
    },
    showL1Stack() {
      return this.model.l1AutoApproved || !!(this.model.l1 && this.model.l1.users.length);
    },
  },
};
</script>
